// This file has to be the first one that is imported for a webpack entry point

// @ts-expect-error has to be defined this way: https://webpack.js.org/configuration/output/#outputpublicpath
__webpack_public_path__ = window.assetPath
